export var FlowTriggerKind;
(function (FlowTriggerKind) {
    FlowTriggerKind["HL7Message"] = "HL7_MESSAGE";
    FlowTriggerKind["VoiceCall"] = "VOICE_CALL";
    FlowTriggerKind["X12Message"] = "X12_MESSAGE";
    FlowTriggerKind["SftpMessage"] = "SFTP_MESSAGE";
    FlowTriggerKind["JobCompletion"] = "JOB_COMPLETION";
    FlowTriggerKind["Form"] = "FORM";
    // Owned by resource-gateway; surfaced here only so the `GET /triggers` query
    // schema can accept `?kind=RESOURCE_EVENT`. Has no row in `flow_triggers`.
    FlowTriggerKind["ResourceEvent"] = "RESOURCE_EVENT";
})(FlowTriggerKind || (FlowTriggerKind = {}));
//# sourceMappingURL=kind.js.map